import React from "react";
import HomeCarousel from "@components/Home/CarouselHome";
import {
  RECOMMENDED_ARTISTS_PAGE_LIMIT,
  RecommendedArtistsData,
  useRecommendedArtists,
} from "@hooks/trpc/useRecommendedArtists";
import { captureException } from "@utils/captureException";

const RecommendedArtists = () => {
  const { data, fetchNextPage, hasNextPage, isFetched } =
    useRecommendedArtists();
  const items: RecommendedArtistsData[] = data.pages.flatMap(
    (page) => page.data,
  );

  const handleEndReached = () => {
    if (hasNextPage) {
      fetchNextPage().catch((error) => {
        captureException(error, {
          channel: "breadcrumb",
          area: "pagination",
          operation: "fetch-next-recommended-artists",
        });
      });
    }
  };

  if (isFetched && items.length === 0) {
    return null;
  }

  return (
    <HomeCarousel
      items={items}
      onEndReached={handleEndReached}
      onEndReachedThreshold={RECOMMENDED_ARTISTS_PAGE_LIMIT}
      screen="home"
      title="Recommended Artists"
    />
  );
};

export default RecommendedArtists;
